<template>
  <div class="view-tasklists" id="main">
    <user-menu />
    <div class="content-wrapper">    
    <div class="container-wrapper center">
      <h3 class="text-align-center col-12 margin-bottom-15 float-left override-padding">
        <div v-if="sub_tasklists_title.edit">
          <input v-model="sub_tasklists_title.name"
                class="font-15 col-lg-8 col-sm-8 col-7 input-height-25"
                maxlength="255" />
          <button
              v-on:click="updateSubTaskListAction()"
              class="btn btn-blue col-lg-2 col-sm-2 col-3 input-height-25"
              ><b>Save</b></button>
        </div>
        <div v-else>
          {{ sub_tasklists_title.name }}
          <i @click="sub_tasklists_title.edit = true;" class="cursor-pointer fa fa-pencil-square-o" style="font-size: 15px !important;" aria-hidden="true" ></i>
        </div>
      </h3>
      <div style="clear: both" ></div>
      <div class="col-lg-5 col-10 center text-align-center">
      <button
          v-if="addHeadingButtonShow"
          v-on:click="HeadingClick()"
          class="btn btn-blue col-lg-5 col-5 input-height-35"
          ><b><i class="fa fa-plus" aria-hidden="true"></i> Add Headings</b></button>
      <button
          v-if="addTaskButtonShow"
          v-on:click="TaskClick()"
          class="btn btn-blue col-lg-5 col-5 input-height-35"
          ><b><i class="fa fa-plus" aria-hidden="true"></i> Add Task</b></button>
      </div>
      <div v-show="addHeadingShow">
      <hr>
      <input
          v-model="headings"
          type="text"
          name="headings"
          id="headings"
          ref="headings"
          placeholder="Enter Headings"
          class="col-lg-9 col-sm-9 col-12 input-height-35"
          maxlength="255" />
      <button
          v-on:click="addHeadingsAction"
          class="btn btn-blue col-lg-2 col-sm-2 col-12 input-height-35"
          ><b><i class="fa fa-plus" aria-hidden="true"></i> Add Headings</b></button>
      </div>

      <div style="clear: both" ></div>
      <hr>
      <div class="heading_list">
        <ul v-sortable="{onEnd: reorderHeading, handle: '.handle1'}" class="counter_heading-list list-group col-lg-12">
          <li class="list-group-item input-height-25" v-for="(heading, index) in sub_tasklist_obj.headings" :key="heading.sortid">
            <div class="heading_item">
              <div v-if="heading.edit" class="float-left col-lg-8 col-7 override-padding">
                <input v-model="heading.name"
                    class="col-lg-8 col-sm-8 col-8 input-height-25"
                    maxlength="255" />
                <button
                    v-on:click="updateHeadingsAction(heading)"
                    class="btn btn-blue col-lg-2 col-sm-2 col-3 input-height-25"
                    ><b>Save</b></button>
              </div>
              <div v-else class="handle1 float-left col-lg-8 col-7 override-padding">
                <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                <span class="counter_heading-list__counter"></span>
                {{ heading.name }}
              </div>
              <div class="float-left font-15 col-lg-1 col-1"><i @click="heading.edit = true;" class="cursor-pointer fa fa-pencil-square-o" aria-hidden="true" ></i></div>
              <div class="float-left font-15 col-lg-1 col-1" v-if="taskListStatus == 'DRAFT'"><i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteHeadingConfirm('', index)"></i></div>
              <div class="float-left font-15 col-lg-2 col-3">
                <button
                    v-on:click="choose_tasks_redirect(index)"
                    class="btn btn-action col-12 input-height-25"
                    ></i> Add Task</button>
              </div>
              <div style="clear: both"></div>
            </div>
            <hr>
            <div class="task_container">
              <div style="clear: both"></div>
              <div class="task_list">
                <ul v-sortable="{onEnd: reorderHeadingTasks, handle: '.handle2', group: { name: 'heading-' + index, put: creategrouparray() } }" class="counter_task-list tasks_list list-group col-lg-12"  :data-id="index">
                   <li class="list-group-item input-height-25" v-for="(task, index1) in heading.tasks" :key="task.sortid">
                     <div class="task_item">
                       <div class="handle2 float-left col-lg-9 col-8 override-padding">
                        <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                        <span class="counter_task-list__counter"></span>
                        {{ task.name }}
                       </div>
                       <div class="float-left col-lg-2 col-3 override-padding">
                       <span v-if="task.priority > 0">
                          P{{ task.priority }}
                        </span>
                        <span v-else>&nbsp;</span>
                       </div>
                       <div class="float-left font-15 col-lg-1 col-1 override-padding"><i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteHeadingTasksConfirm(index, index1)"></i></div>
                     </div>
                     <div style="clear: both"></div>
                   </li>
                 </ul>
             </div>
           </div>
          </li>
        </ul>
      </div>

      <div v-if="sub_tasklist_obj.tasks.length > 0" class="subtask_task_list">
        <ul v-sortable="{onEnd: reorderTask, handle: '.handle3'}" class="counter_task-list col-lg-12">
           <li class="input-height-25" v-for="(task, index2) in sub_tasklist_obj.tasks"  :key="task.sortid">
             <div class="task_item">
               <div class="handle3 float-left col-lg-9 col-8 override-padding">
                <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                <span class="counter_task-list__counter"></span>
                {{ task.name }}
               </div>
               <div class="float-left col-lg-2 col-3 override-padding">
                 <span v-if="task.priority > 0">
                    P{{ task.priority }}
                 </span>
                 <span v-else>&nbsp;</span>
               </div>
               <div class="float-left font-15 col-lg-1 col-1 override-padding"><i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteHeadingTasksConfirm('', index2)"></i></div>
             </div>
             <div style="clear: both"></div>
           </li>
         </ul>
     </div>

     <div style="clear: both" class="margin-bottom-20"></div>
     <div v-if="this.sub_tasklist_obj.headings.length > 0 || this.sub_tasklist_obj.tasks.length > 0 || this.sub_tasklist_obj.remove_headings.headings.length > 0 || this.sub_tasklist_obj.remove_tasks.length > 0" class="submit float-right col-lg-2 col-4 override-padding" @click="onSubmit">
       <button type="submit" class="col-12 btn btn-info btn-md input-height-35">Save List</button>
     </div>
   </div>

   <div style="clear: both" class="margin-bottom-20"></div>

    <DeleteModal :isModalVisible="isModalVisible" :id="id" :parent_id="parent_id" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure want to Delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-blue" @click="isModalVisible = false; deleteHeadingTasksAction(id, parent_id)">Confirm</button>
      </div>
    </DeleteModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure want to Delete? This will delete tasks related.</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-blue" @click="isDeleteModalVisible = false; deleteHeadingAction(id, parent_id)">Confirm</button>
      </div>
    </DeleteModal>

    <ValidationModal :isModalVisible="isValidationModalVisible" @close="isValidationModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Please enter heading title</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ValidationModal>

    <ValidationModal :isModalVisible="isInfoModalVisible" @close="isInfoModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">The task shouldn't be removed because it has assessments.</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
      </div>
    </ValidationModal>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import DeleteModal from '../shared/delete_modal_alert.vue';
import ValidationModal from '../shared/validation_modal_alert.vue';
import Sortable from 'sortablejs';


Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});


export default {
        data() {
          return {
            sub_tasklists_title: {
              "name": '',
              "edit": false,
            },
            headings: '',
            tasks: '',
            task: [],
            sub_tasklist_obj: {
              headings: [],
              tasks: [],
              remove_headings: {
                headings: [],
                tasks: [],
              },
              remove_tasks: [],
              heading_sort_flag: false,
              headingtask_sort_headingId: [],
              task_sort_flag: false,
            },
            isModalVisible: false,
            isDeleteModalVisible: false,
            id: '',
            parent_id: '',
            loading: false,
            remove_data: [],
            addHeadingShow: false,
            addHeadingButtonShow: true,
            addTaskButtonShow: true,
            isValidationModalVisible: false,
            isInfoModalVisible: false,
            taskListStatus: '',
          }
        },
        components: {
          UserMenu,
          GoBack,
          DeleteModal,
          ValidationModal
        },
        methods: {
          onSubmit () {
            axios('/headings-tasks',
               {
                 method: 'POST',
                 data: {
                    "sub_tasklist_obj": this.sub_tasklist_obj,
                    "sub_tasklist_id": this.$route.params.sub_task_list_id,
                    "tasklist_id": this.$route.params.task_list_id
                 },
               })
            .then((resp) => {
                this.$store.dispatch('headings_tasks', '');
                this.$store.dispatch('subtasks', '');
                router.push("/create-sub-tasklists/" + this.$route.params.task_list_id);
             })
            .catch(error => {

            });
          },
          creategrouparray: function() {
            var group_list = [];
            for(var i=0; i < this.$store.state.sub_tasks_obj.headings.length; i++) {
              group_list.push('heading-' + i);
            }
            return group_list;
          },
          updateSubTaskListAction: function() {
            axios('/sub-tasklists/' + this.$route.params.sub_task_list_id,
               {
                 method: 'PATCH',
                 data: {name: this.sub_tasklists_title.name},
               }
             )
            .then((resp) => {
                this.loadSubTaskListTitleAction();
             })
            .catch(error => {
              if(error.response.data.code == '404') {
                router.push("/view-tasklist");
              }

            });
          },

          choose_tasks_redirect: function (index) {
            router.push("/choose-tasks/" + this.$route.params.sub_task_list_id + "/" + this.$route.params.task_list_id + "/" + index);
          },
          addHeadingsAction: function() {
            if(this.headings === '') {
              this.isValidationModalVisible = true;
              return false;
            }
            var heading_len = this.sub_tasklist_obj.headings.length + 1;
            this.sub_tasklist_obj.headings.push({
              id: '',
              name: this.headings,
              edit: false,
              update: false,
              modified: false,
              sortid: 'heading-' + heading_len,
              tasks: [],
            });
            this.headings = '';
            this.sub_tasklist_obj.heading_sort_flag = true;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
            this.checkButtonDisplay();
          },
          updateHeadingsAction: function(heading) {
            if(heading.name === '') {
              this.isValidationModalVisible = true;
              return false;
            }
            if(heading.update === true) {
              heading.modified = true;
            }
            heading.edit = false;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
          },
          deleteHeadingTasksConfirm: function(parent_id, id) {
            var task_id;
            if(parent_id === '') {
              task_id = this.sub_tasklist_obj.tasks[id].id;
            }
            else {
              task_id = this.sub_tasklist_obj.headings[parent_id].tasks[id].id;
            }
            var tasklist_id = this.$route.params.task_list_id;
            this.getAssessmentCount(tasklist_id, task_id, parent_id, id);
          },
          deleteHeadingConfirm: function(parent_id, id) {
            this.isDeleteModalVisible = true;
            this.id = id;
            this.parent_id = parent_id;
          },
          deleteHeadingAction: function(id, parent_id) {
            this.remove_data = this.sub_tasklist_obj.headings[id];
            if((this.remove_data.id == '') || (this.remove_data.update === false)) {
              this.sub_tasklist_obj.headings.splice(id, 1);
            }
            else {
              this.sub_tasklist_obj.remove_headings.headings.push({
                heading_id: this.sub_tasklist_obj.headings[id].id,
              });
              this.sub_tasklist_obj.headings.splice(id, 1);
            }
            var j=1;
            for(var i=0; i < this.sub_tasklist_obj.headings.length; i++) {
              this.sub_tasklist_obj.headings[i].sortid = 'heading-' + j;
              j++;
            }
            this.remove_data = [];
            this.isDeleteModalVisible = false;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
            this.checkButtonDisplay();
          },
          deleteHeadingTasksAction: function(id, parent_id) {
            if(parent_id === '') {
              this.remove_data = this.sub_tasklist_obj.tasks[id];
              if((this.remove_data.id == '') || (this.remove_data.update === false)) {
                this.sub_tasklist_obj.tasks.splice(id, 1);
              }
              else {
                this.sub_tasklist_obj.remove_tasks.push({
                  task_id: this.sub_tasklist_obj.tasks[id].id,
                });
                this.sub_tasklist_obj.tasks.splice(id, 1);
              }
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++) {
                this.sub_tasklist_obj.tasks[i].sortid = 'task-' + j;
                j++;
              }
            }
            else {
              this.remove_data = this.sub_tasklist_obj.headings[parent_id].tasks[id];
              if((this.remove_data.id == '') || (this.remove_data.update === false)) {
                this.sub_tasklist_obj.headings[parent_id].tasks.splice(id, 1);
              }
              else {
                this.sub_tasklist_obj.remove_headings.tasks.push({
                  task_id: this.sub_tasklist_obj.headings[parent_id].tasks[id].id,
                  heading_id: this.sub_tasklist_obj.headings[parent_id].id,
                });
                this.sub_tasklist_obj.headings[parent_id].tasks.splice(id, 1);
              }
              var parent_sortid = this.sub_tasklist_obj.headings[parent_id].sortid;
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.headings[parent_id].tasks.length; i++) {
                this.sub_tasklist_obj.headings[parent_id].tasks[i].sortid = parent_sortid + '-task-' + j;
                j++;
              }
            }
            this.remove_data = [];
            this.isModalVisible = false;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
            this.checkButtonDisplay();
          },
          checkButtonDisplay: function() {
            var heading_flag = 0;
            var task_flag = 0;
            if(this.$store.state.sub_tasks_obj.headings) {
              if(this.$store.state.sub_tasks_obj.headings.length > 0) {
                heading_flag = 1;
              }
            }
            if(this.$store.state.sub_tasks_obj.tasks) {
              if(this.$store.state.sub_tasks_obj.tasks.length > 0) {
                task_flag = 1;
              }
            }
            if((heading_flag == 0) && (task_flag == 0)) {
              this.addHeadingButtonShow = true;
              this.addHeadingShow = false;
              this.addTaskButtonShow = true;
            }
            else if(heading_flag == 1) {
              this.addHeadingButtonShow = false;
              this.addHeadingShow = true;
              this.addTaskButtonShow = false;
            }
            else if(task_flag == 1) {
              this.addHeadingButtonShow = false;
              this.addHeadingShow = false;
              this.addTaskButtonShow = true;
            }
          },
          HeadingClick() {
            this.addHeadingButtonShow = false;
            this.addHeadingShow = true;
            this.addTaskButtonShow = false;
          },
          TaskClick() {
            this.addTaskButtonShow = true;
            router.push("/choose-tasks/" + this.$route.params.sub_task_list_id + "/" + this.$route.params.task_list_id + "/null");
          },
          loadSubTaskListTitleAction: function() {
            axios('/sub-tasklist-title/' + this.$route.params.sub_task_list_id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
              this.sub_tasklists_title.name = resp.data;
              this.sub_tasklists_title.edit = false;
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
              else if(error.response.data.code == '404') {
                router.push("/view-tasklist");
              }
            })
          },
          loadHeadingsTasksAction: function() {
            this.$store.dispatch('headings_tasks', '');
            axios('/headings-tasks/' + this.$route.params.sub_task_list_id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
              for(var i=0; i < resp.data.headings.length; i++) {
                this.sub_tasklist_obj.headings.push(resp.data.headings[i]);
              }
              this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
              for(var i=0; i < resp.data.tasks.length; i++) {
                this.sub_tasklist_obj.tasks.push(resp.data.tasks[i]);
              }
              this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
              this.checkButtonDisplay();
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
              else if(error.response.data.code == '404') {
                router.push("/view-tasklist");
              }
            })
          },
          reorderHeadingTasks (event) {
            var from_index = event.from.attributes[1].value;
            var to_index = event.to.attributes[1].value;
            if(from_index === to_index) {
              var parent_index = event.from.attributes[1].value;
              const movedItem = this.sub_tasklist_obj.headings[parent_index].tasks.splice(event.oldIndex, 1)[0];
              this.sub_tasklist_obj.headings[parent_index].tasks.splice(event.newIndex, 0, movedItem);
              this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.headings[parent_index].id);
              this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
            }
            else {
              if (this.sub_tasklist_obj.headings[from_index].tasks[event.oldIndex].update == true) {
                this.sub_tasklist_obj.remove_headings.tasks.push({
                  task_id: this.sub_tasklist_obj.headings[from_index].tasks[event.oldIndex].id,
                  heading_id: this.sub_tasklist_obj.headings[from_index].id,
                });
              }
              const movedItem = this.sub_tasklist_obj.headings[from_index].tasks.splice(event.oldIndex, 1)[0];
              movedItem.update = false;
              movedItem.modified = false;
              this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.headings[from_index].id);
              this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.headings[to_index].id);
              this.sub_tasklist_obj.headings[to_index].tasks.splice(event.newIndex, 0, movedItem);
              var parent_sortid = this.sub_tasklist_obj.headings[to_index].sortid;
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.headings[to_index].tasks.length; i++) {
                this.sub_tasklist_obj.headings[to_index].tasks[i].sortid = parent_sortid + '-task-' + j;
                j++;
              }
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.headings[from_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.headings[from_index].tasks.length; i++) {
                  this.sub_tasklist_obj.headings[from_index].tasks[i].sortid = parent_sortid + '-task-' + j;
                  j++;
                }
                this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
              }, 300);
            }
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
          },
          reorderHeading ({oldIndex, newIndex}) {
            const movedItem = this.sub_tasklist_obj.headings.splice(oldIndex, 1)[0];
            this.sub_tasklist_obj.headings.splice(newIndex, 0, movedItem);
            this.sub_tasklist_obj.heading_sort_flag = true;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
          },
          reorderTask ({oldIndex, newIndex}) {
            const movedItem = this.sub_tasklist_obj.tasks.splice(oldIndex, 1)[0];
            this.sub_tasklist_obj.tasks.splice(newIndex, 0, movedItem);
            this.sub_tasklist_obj.task_sort_flag = true;
            this.$store.dispatch('headings_tasks', this.sub_tasklist_obj);
          },
          getAssessmentCount(tasklist_id, task_id, parent_id, id) {
            axios('/check-assessmentcnt-tasks/' + tasklist_id +'/'+ task_id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
               var assessmentCount = resp.data[0].totalAssessment;
               if(assessmentCount == 0) {
                 this.isModalVisible = true;
                 this.id = id;
                 this.parent_id = parent_id;
               }
               else {
                 this.isInfoModalVisible = true;
               }
             })
             .catch(error => {

             })
          },
        },
        created: function () {
          this.loadSubTaskListTitleAction();
          if((!this.$store.state.sub_tasks_obj.headings) && (!this.$store.state.sub_tasks_obj.tasks)) {
            this.loadHeadingsTasksAction();
          }
          if(this.$store.state.sub_tasks_obj.headings) {
            for(var i=0; i < this.$store.state.sub_tasks_obj.headings.length; i++) {
              this.sub_tasklist_obj.headings.push(this.$store.state.sub_tasks_obj.headings[i]);
            }
          }
          if(this.$store.state.sub_tasks_obj.tasks) {
            for(var i=0; i < this.$store.state.sub_tasks_obj.tasks.length; i++) {
              this.sub_tasklist_obj.tasks.push(this.$store.state.sub_tasks_obj.tasks[i]);
            }
          }
          if(this.$store.state.sub_tasks_obj.remove_headings) {
            for(var i=0; i < this.$store.state.sub_tasks_obj.remove_headings.headings.length; i++) {
              this.sub_tasklist_obj.remove_headings.headings.push(this.$store.state.sub_tasks_obj.remove_headings.headings[i]);
            }
            for(var i=0; i < this.$store.state.sub_tasks_obj.remove_headings.tasks.length; i++) {
              this.sub_tasklist_obj.remove_headings.tasks.push(this.$store.state.sub_tasks_obj.remove_headings.tasks[i]);
            }
          }
          if(this.$store.state.sub_tasks_obj.remove_tasks) {
            for(var i=0; i < this.$store.state.sub_tasks_obj.remove_tasks.length; i++) {
              this.sub_tasklist_obj.remove_tasks.push(this.$store.state.sub_tasks_obj.remove_tasks[i]);
            }
          }
          if(this.$store.state.sub_tasks_obj.heading_sort_flag){
            this.sub_tasklist_obj.heading_sort_flag = this.$store.state.sub_tasks_obj.heading_sort_flag;
          }
          else {
            this.sub_tasklist_obj.heading_sort_flag = false;
          }
          if(this.$store.state.sub_tasks_obj.task_sort_flag){
            this.sub_tasklist_obj.task_sort_flag = this.$store.state.sub_tasks_obj.task_sort_flag;
          }
          else {
            this.sub_tasklist_obj.task_sort_flag = false;
          }
          if(this.$store.state.sub_tasks_obj.headingtask_sort_headingId) {
            for(var i=0; i < this.$store.state.sub_tasks_obj.headingtask_sort_headingId.length; i++) {
              this.sub_tasklist_obj.headingtask_sort_headingId.push(this.$store.state.sub_tasks_obj.headingtask_sort_headingId[i]);
            }
          }
          this.checkButtonDisplay();
        },
        mounted() {
          var tasklist_id = this.$route.params.task_list_id;
          axios('/get-tasklist-status/' + tasklist_id,
            {
              method: 'GET',
            }
          )
          .then(resp => {
             this.taskListStatus = resp.data.status;
          })
          .catch(error => {

          })
        },
}
</script>

<style scoped>
  .btn {
    padding: 1px 0px;
  }
  .margin-top-10 {
    margin-top: 10px;
  }
  .margin-left-20 {
    margin-left: 0px;
  }
  .padding-right-5 {
    padding-right: 5px;
  }
  .container-wrapper ul {
    list-style: none;
    padding: 0px;
  }
  .heading_list ul li {
    padding: 0;
    border: 1px solid #CCC;
    margin-top: 10px;
    float: left;
    width: 100%;
    margin-left: 0px;
  }
  .subtask_task_list ul li {
    padding: 5px 15px;
    margin-top: 10px;
    float: left;
    width: 100%;
  }
  .subtask_task_list {
    border: 1px solid #CCC;
    float: left;
    width: 100%;
    margin-top: 20px;
  }
  .heading_list hr {
    margin: 0px 0px 20px 0px;
  }
  .heading_item {
    background-color: #CCC;
    padding: 5px 15px;
  }
  .task_list ul li {
    padding: 5px 0px;
    border: 0;
    float: left;
    margin-left: 0px;
  }
  .task_container {
    padding: 5px 20px 5px 50px;
  }
  .sub_task_list_display {
    border: 1px  solid #333;
    float: left;
  }
  .add_task_fields {
    margin-bottom: 10px;
  }
  .task_container input.add_task {
    border: 0;
    border-bottom: 1px solid #CCC;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/create_headings_tasks.vue